import React, { createContext, useContext, useState, useCallback } from 'react';

const DeclarationBreadcrumbContext = createContext(null);

export function DeclarationBreadcrumbProvider({ children }) {
  const [exportIndex, setExportIndex] = useState(-1);
  const [itemIndex, setItemIndex] = useState(-1);

  const setDeclarationBreadcrumb = useCallback((exportIdx, itemIdx) => {
    setExportIndex(typeof exportIdx === 'number' ? exportIdx : -1);
    setItemIndex(typeof itemIdx === 'number' ? itemIdx : -1);
  }, []);

  const value = { exportIndex, itemIndex, setDeclarationBreadcrumb };
  return (
    <DeclarationBreadcrumbContext.Provider value={value}>
      {children}
    </DeclarationBreadcrumbContext.Provider>
  );
}

export function useDeclarationBreadcrumb() {
  const ctx = useContext(DeclarationBreadcrumbContext);
  return ctx;
}
